<h1 mat-dialog-title><i class="fas fa-2x fa-check-circle"></i></h1>
<div mat-dialog-content><h2>Vos modifications sont enregistrés avec succès !</h2></div>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close class="valider-modif">
      <a [routerLink]="[ './']" title="panier">Continuer vos achats</a>
  </button>
  <!-- <button mat-button mat-dialog-close class="valider-modif">Ok</button> -->
</mat-dialog-actions>
